<template>
    <div class="_common_components_qrcode" v-if="qrUrl">
        <div
            class="qrcode-container"
            :style="{ width: imgWidthRem, padding: paddingNumRem }"
            :class="{ 'show-border': showBorder }"
        >
            <img :src="qrUrl" />
        </div>
    </div>
</template>

<script >
import QrCode from 'qrcode';
import { defineProps, onMounted, ref, watch } from 'vue-demi';
import { SHOW_BORDER, QR_CONTENT_TYPE, RATIO } from './config';
const __sfc_main = {};
__sfc_main.props = {
  paddingNum: {
    type: Number,
    default: 0
  },
  borderColor: {
    type: String,
    default: '#FEE5BE'
  },
  qrCodeContent: {
    type: Number,
    default: QR_CONTENT_TYPE.CUSTOM
  },
  paramName: {
    type: String,
    default: ''
  },
  fixedContent: {
    type: String,
    default: ''
  },
  showBorder: {
    type: Number,
    default: SHOW_BORDER.SHOW
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const paddingNumRem = ref('0rem');
  const qrUrl = ref('');
  const props = __props;
  const initData = async () => {
    paddingNumRem.value = `${Math.round((props.paddingNum || 0) * RATIO) / RATIO / RATIO}rem`;

    // 固定文案
    if (props.qrCodeContent === QR_CONTENT_TYPE.CUSTOM) {
      if (!props.fixedContent) {
        return;
      }
      qrUrl.value = await QrCode.toDataURL(props.fixedContent, {
        margin: 0
      });
      return;
    }
    if (!props.paramName) {
      return;
    }

    // 初始化时如果已有数据，直接生成二维码
    // 但是如果有初始值的话还是会需要更新
    if (FEGORender?.store?.variable?.data?.[props.paramName]) {
      const initialValue = FEGORender.store.variable.data[props.paramName];
      qrUrl.value = await QrCode.toDataURL(initialValue, {
        margin: 0
      });
    }
    const store = FEGORender.store.variable.data;
    watch(() => store[props.paramName], async newVal => {
      if (!newVal) {
        return;
      }
      qrUrl.value = await QrCode.toDataURL(newVal, {
        margin: 0
      });
    }, {
      immediate: true
    });
  };
  onMounted(async () => {
    await initData();
  });
  return {
    paddingNumRem,
    qrUrl
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
._common_components_qrcode {
    height: 100%;
    width: 100%;
    .qrcode-container,
    img {
        width: 100%;
        height: 100%;
    }
    .show-border {
        box-sizing: border-box;
        border: 1px solid #fee5be;
        border-radius: 0.08rem;
    }
}
</style>
